import Vue from 'vue';

Vue.component('hidden-container-push', () => import('./modules/hidden-container/push'));
Vue.component('hidden-container-overlay', () => import('./modules/hidden-container/overlay'));

Vue.component('google-maps', () => import('./modules/google-maps'));
Vue.component('list', () => import('./modules/list'));
